import __env from '../../../env'
import instance from '../../../middleware/axiosInstance'
import axios from 'axios'


export const createDag = data => {
  return instance.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/`, data)
}

export const startDag = cacheId => {
  return instance.post(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/start/${cacheId}`
  )
}

export const stopDag = cacheId => {
  return instance.delete(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/stop/${cacheId}`
  )
}

export const deleteDag = cacheId => {
  return instance.delete(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/${cacheId}`
  )
}

export const fetchDag = (cacheType) => {

  return instance.get(`${process.env.REACT_APP_CACHE_URL}/cache/workflow/get/video-config-identifiers?cacheType=${cacheType}`,{withCredentials:true})

}

export const fetchDagWithPagination = (pageable, search) => {
  return instance.get(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/all?pageNo=${pageable.pageNo}&pageSize=${pageable.pageSize}&sortBy=${pageable.sortBy}&sortDir=${pageable.sortDir}&searchBy=${search}`
  )
}

export const ChangeDagStatus = (id, workflowState) => {
  return instance.post(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/state/change/${id}?state=${workflowState}`
  )
}

export const downloadTlCsv = data => {
  return instance.get(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/csv/cache-csv?fileName=${data?.['workflow-name']}&workflowId=${data['id']}`
  )
}

export const downloadOverlayCsv = (data ,usecaseId)=> {
  return instance.get(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/csv/overlay-csv?workflowId=${data?.['id']}`
  )
}

export const getIterationCountStatus=(workflowId,page,itemsPerPage)=>{
  return instance.get(`${process.env.REACT_APP_CACHE_URL}/cache/iterations/mlAndMlt/page?page-number=${page}&page-size=${itemsPerPage}&sort-by=DESC&sort-dir=DESC&workflow-id=${workflowId}`)
}

export const getIterationMltCountStatus=(workflowId,page,itemsPerPage)=>{
  return instance.get(`${process.env.REACT_APP_CACHE_URL}/cache/iterations/mlt/page?page-number=${page}&page-size=${itemsPerPage}&sort-by=DESC&sort-dir=DESC&workflow-id=${workflowId}`)
}

export const getIterationOverlayCountStatus=(workflowId,page,itemsPerPage)=>{
  return instance.get(`${process.env.REACT_APP_CACHE_URL}/cache/iterations/overlay/page?page-number=${page}&page-size=${itemsPerPage}&sort-by=DESC&sort-dir=DESC&workflow-id=${workflowId}`)
}

export const cacheWorklowPartsStatus=(iterationId,responseType,pageable)=>{
  return instance.get(`${process.env.REACT_APP_CACHE_URL}/cache/iterations/cache/parts?page-number=${pageable.pageNo}&page-size=10&sort-by=${pageable.sortDir}&sort-dir=${pageable.sortDir}&iteration-id=${iterationId}&response-type=${responseType}`)
}


export const downloadMltCsv = data => {

  return instance.get(
    `${process.env.REACT_APP_SCHEMA_URL}/admin/csv/kden-csv?fileName=${data?.['workflow-name']}&workflowId=${data['id']}&useCaseId=${data['use-case-id']}`
  )
}

// export const dagCount = workflowName => {
//   return instance.get(
//    `${process.env.REACT_APP_CACHE_URL}/cache/get/count?workflowName=${workflowName}`
//   )
// }

// export const kdenCount = workflowName => {
//   return instance.get(
//    `${process.env.REACT_APP_CACHE_URL}/cache/get/count?workflowName=${workflowName}`
//   )
// }

export const dagCount = workflowName => {
  return instance.get(
   `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/details/${workflowName}`
  )
}

export const kdenCount = workflowName => {
  return instance.get(
   `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/details/${workflowName}`
  )
}

export const getWorkflowByName = workflowName => {
  return instance.get(
   `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/name/${workflowName}`
  )
}

export const addComments=(data,id)=>{
  return instance.post(
   `${process.env.REACT_APP_SCHEMA_URL}/admin/workflow/state/change/${id}`,data
  )
  }

  export const retryFailedVideos=(id)=>{

    return instance.get(

     `${process.env.REACT_APP_CACHE_URL}/cache/iterations/retry?iteration-id=${id}`,{withCredentials:true}
    )
    }




